import React, { useState } from "react";
import Logo from "../OnboardingRevampPage/Logo";
import { useDispatch, useSelector } from "react-redux";
import { Line } from "rc-progress";
import { useEffect } from "react";
import PricingCard from "../OnboardingRevampPage/PricingCard";
import BenefitsSection from "../OnboardingRevampPage/BenefitsSection";
import ReviewSection from "../OnboardingRevampPage/ReviewSection";
import FAQSection from "../OnboardingRevampPage/FAQSection";
import useWindowSize from "../../hooks/useWindowSize";
import SuccessStoriesSection from "../OnboardingRevampPage/SuccessStoriesSection";
import RecognitionSection from "../OnboardingRevampPage/RecognitionSection";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";
import {
  dispatchUserPersonaliseCourseSelection,
  fetchPaymentId,
  fetchRazorPayStatus,
} from "../../redux/actions/personaliseCourse";
import useRazorpay from "react-razorpay";
import { RAZORPAY_KEY } from "../../config/api_config";
import { useNavigate } from "react-router-dom";
import GraphSection from "../OnboardingRevampPage/GraphSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import LearntubeStatsSection from "../OnboardingRevampPage/LearntubeStatsSection";
import OurLearnersWorkAt from "../../components/Carousel";
import BottomEvenPersonaliseSection from "./BottomEvenPersonalisationSection";
import "./index.css";
import { useSearchParams } from "react-router-dom";

const cradFeatures = [
  "Industry-Verified Certification",
  "Lifetime Access to 3100+ More Courses",
  "Live Doubt Solving",
];

const PersonalisedAnalysis = () => {
  const userName = useSelector((state) => state.profileDetails?.name);
  const skillName = useSelector((state) => state.personaliseCourse?.skill_name);
  const skillslug = useSelector((state) => state.personaliseCourse?.skill_slug);
  const analysis = useSelector((state) => state.personaliseCourse?.analysis);
  const skillDetails = useSelector(
    (state) => state.personaliseCourse?.skillDetails,
  );
  const score = useSelector((state) => state.personaliseCourse?.score);
  const email = useSelector((store) => store?.profileDetails?.email);
  const uuid = useSelector((state) => state?.personaliseCourse?.UUID);
  const phoneNumber = useSelector(
    (state) => state?.profileDetails?.["phone-number"],
  );
  const rank = useSelector((state) => state?.personaliseCourse?.rank);
  const onboardingData = useSelector(
    (state) => state?.personaliseCourse?.onboardingData,
  );
  const customisedSkill = useSelector(
    (state) => state.personaliseCourse?.customSkillSelected,
  );

  const [userWrong, setUserWrong] = useState([]);

  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const Razorpay = useRazorpay();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS, {
      distinct_id: email,
    });
    setUserWrong(
      analysis?.user_weak_areas
        ?.split("\n")
        ?.filter?.((item) => item?.length > 0),
    );
  }, []);

  const razorpayHandler = (callback) => {
    dispatch(
      fetchPaymentId(uuid, 199, "Personalise Course", (successObj) => {
        const options = {
          key: RAZORPAY_KEY,
          amount: `${199 * 100}`,
          currency: "INR",
          name: skillName,
          description: "Personalise Course",
          order_id: successObj?.razorpay_order_id,
          modal: {
            ondismiss: function () {
              callback();
            },
          },
          handler: (res) => {
            getOrderStatusSuccess(res);
            callback();
          },
          prefill: {
            name: userName,
            email: email,
            contact: phoneNumber,
          },
          // notes: {
          //     address: "Razorpay Corporate Office"
          // },
          theme: {
            color: "#26CBA7",
          },
        };
        const razorpayInitializor = new Razorpay(options);
        razorpayInitializor.on("payment.failed", function (response) {
          getOrderStatusFailure(response);
          callback();
        });
        razorpayInitializor.open();
      }),
    );
  };

  const getOrderStatusSuccess = async (response) => {
    await dispatch(
      fetchRazorPayStatus({
        uuid: uuid,
        payment_id: response?.razorpay_payment_id,
        order_id: response?.razorpay_order_id,
        isError: false,
        razorpay_signature: response?.razorpay_signature,
        errorObj: {},
      }),
    );
    await dispatch(dispatchUserPersonaliseCourseSelection(true));
    window.location.href = `https://personalise.learntube.ai/onboarding/loader-2?skill_slug=${skillslug}&uuid=${uuid}&email=${email}&name=${userName}&skill_level=${skillDetails?.skill}`;
  };

  const getOrderStatusFailure = async (response) => {
    dispatch(
      fetchRazorPayStatus({
        uuid: uuid,
        payment_id: response?.error?.metadata?.payment_id,
        order_id: response?.error?.metadata?.order_id,
        isError: true,
        razorpay_signature: "",
        errorObj: { ...response?.error },
      }),
    );
  };

  const handleSkip = () => {
    if (customisedSkill) {
      if (searchParams.get("course")) {
        navigate(`/popular-course/${searchParams?.get("course")}`);
      } else {
        navigate("/courses");
      }
    } else {
      navigate(
        `/${onboardingData.course_slug}/${onboardingData.skill_slug}/${onboardingData.mskill_slug}/${onboardingData.id}`,
      );
    }
  };

  return (
    <div className="parent-radial-gradient-background min-h-screen text-white">
      <div
        className="absolute top-5 right-6 z-50 cursor-pointer md:top-8 md:right-10"
        onClick={() => {
          Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_SKIP);
          handleSkip();
        }}
      >
        <p className="font-semibold text-[#1983D0] underline">Skip</p>
      </div>
      <div className="p-4 md:mx-auto md:w-2/3 md:p-6">
        <Logo />
        <h2 className="mb-4 text-center text-2xl font-semibold leading-7 md:my-8 md:text-[32px] md:leading-9">
          {userName?.split(" ")?.[0]}, Here Is Your Analysis For {skillName}
        </h2>
        <div className="rounded-2xl bg-[#2D4F71] p-4">
          <div className="flex items-center justify-between">
            <p className="text-sm md:text-xl">
              Your Score:{" "}
              <span
                className={`${
                  score <= 20 ? "text-[#E06064]" : "text-[#F59E0B]"
                } font-bold`}
              >
                {score}
              </span>
            </p>
            <div className="flex flex-1 justify-center pl-14 md:pl-24">
              <p className="text-left text-xs md:text-xl">
                Your Skill Level:{" "}
                <span className="font-bold text-[#F59E0B]">
                  {score <= 20
                    ? "Newbie"
                    : score <= 50
                    ? "Amateur"
                    : "Intermediate"}
                </span>
              </p>
            </div>
          </div>
          <div className="mt-0.5 flex items-center justify-between md:mt-0">
            <p className="text-sm md:text-xl">
              Your Rank:{" "}
              <span className="font-bold text-[#F59E0B]">{rank}</span>/731
            </p>
            <div className="relative w-[50%]">
              <Line
                strokeWidth={width < 768 ? "3" : "2"}
                strokeColor="#2BBD13"
                percent={score + 1}
                trailWidth={width < 768 ? "3" : "2"}
              />
              <div
                className="absolute -top-1.5 h-4 w-4 md:-top-2 md:h-5 md:w-5"
                style={{ left: `${score}%` }}
              >
                <img
                  src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/Vector.svg?updatedAt=1685338311398"
                  alt="star icon"
                  className="h-full w-full"
                />
              </div>
            </div>
          </div>
          <div className="mt-3 md:mt-5">
            <h3 className="mb-2 font-semibold md:mb-1 md:text-xl">
              Your Analysis
            </h3>
            {userWrong?.map((item, index) => (
              <div
                key={index}
                className={`flex flex-col bg-[#1D3854] ${
                  index === 0 ? "rounded-t-xl" : ""
                } ${index === userWrong?.length - 1 ? "rounded-b-xl" : ""}`}
              >
                <div className="flex items-center p-3">
                  <div className="mr-3 h-auto w-[20px]">
                    <img
                      src="https://img.learntube.ai/public-assets/Onboarding_Revamp/cross%2021.png?updatedAt=1694700171563"
                      alt="cross icon"
                      className="h-full w-full"
                    />
                  </div>
                  <p className="w-[85%] text-sm text-white">{item}</p>
                </div>
                <div className="h-[2px] w-full bg-[#2D4F71]" />
              </div>
            ))}
          </div>
        </div>
        <div className="mt-6">
          <h3 className="mb-2 text-xl font-semibold leading-6 md:mb-4">
            Want To Fix These & Be An Expert With A Course Built Just For You?
          </h3>
          <PricingCard
            razorpayHandler={razorpayHandler}
            onboardingData={onboardingData}
            handleSkip={handleSkip}
          />
          <div className="mt-5 rounded-2xl bg-[#2D4F71] p-4 md:hidden">
            <p className="font-medium">
              What’s Included With Personalised Course
            </p>
            <div className="mt-3 w-full">
              <img
                src="https://img.learntube.ai/public-assets/Onboarding_Revamp/Group%206770.png?updatedAt=1694519221181"
                alt="demo certificate"
                className="h-auto w-full"
              />
            </div>
            <div>
              {cradFeatures?.map((item, index) => (
                <div
                  key={index}
                  className="mt-2 flex items-center justify-center rounded-lg bg-[#1C3956] py-2 px-1"
                >
                  <FontAwesomeIcon icon={faCircleCheck} color="#4AAD60" />
                  <p className="ml-2 text-sm font-semibold">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-6 md:mt-8">
          <h3 className="mb-2 text-xl font-semibold md:mb-3">
            You, Can Change Your Career Now!
          </h3>
          <GraphSection />
        </div>
        <div className="mt-6 md:mt-8">
          <h3 className="mb-2 text-xl font-semibold md:mb-3">
            Benefits Of Our Personalised Course
          </h3>
          <BenefitsSection />
        </div>
        <div className="mt-6 md:mt-8">
          <h2 className="mb-2 text-xl font-semibold md:mb-3">
            Success Stories
          </h2>
          <SuccessStoriesSection />
        </div>
        <div className="mt-5 md:mt-7">
          <h2 className="mb-2 text-xl font-semibold md:mb-3">
            LearnTube Stats
          </h2>
          <LearntubeStatsSection />
        </div>
        <div className="mt-6 md:mt-8">
          <h2 className="mb-2 text-xl font-semibold md:mb-3">
            Our Learners Really Love Us
          </h2>
          <ReviewSection />
        </div>
        <div className="mt-6 md:mt-8">
          <h2 className="mb-2 text-xl font-semibold md:mb-3">
            Our Learners Work At
          </h2>
          <OurLearnersWorkAt />
        </div>
        <div className="mt-6 md:mt-8">
          <h2 className="mb-2 text-xl font-semibold md:mb-3">Recongised By</h2>
          <RecognitionSection />
        </div>
        <div className="mt-6 md:mt-8">
          <BottomEvenPersonaliseSection
            razorpayHandler={razorpayHandler}
            onboardingData={onboardingData}
            handleSkip={handleSkip}
          />
        </div>
        <div className="mt-3 flex items-center justify-center">
          <div className="h-8 w-8">
            <img
              src="https://img.learntube.ai/public-assets/Onboarding_Revamp/image%20532.png?updatedAt=1694587310461"
              className="h-full w-full object-cover"
              alt="money back image"
            />
          </div>
          <p className="ml-1.5 text-xs md:text-sm">100% Moneyback Gurantee</p>
        </div>
        <div className="mt-6 md:mt-8">
          <h2 className="mb-2 text-xl font-semibold md:mb-3">
            Frequently Asked Questions
          </h2>
          <FAQSection />
        </div>
      </div>
    </div>
  );
};

export default PersonalisedAnalysis;
